import React from "react";
import { useTranslations } from "../../../helpers/translations";
import { Button } from "@/components/ui/button";
import { RAILS_ROUTES } from "../helpers/routes";

export const FeaturedLinks = () => {
  const t = useTranslations("nav");

  return (
    <div className="flex items-center gap-xs xl:gap-md">
      <Button
        asChild
        variant="secondaryGray"
        size="sm"
        className="dark no-underline hover:no-underline h-4xl max-[1230px]:px-md"
      >
        <a
          data-analytic-id="navbar-free-video-call-link"
          href={t("video_call.href")}
        >
          {t("video_call.text")}
        </a>
      </Button>

      <Button
        asChild
        variant="default"
        size="sm"
        className="dark no-underline hover:no-underline h-4xl max-[1230px]:px-md"
      >
        <a
          data-analytic-id="main-nav-new-design-button"
          href={RAILS_ROUTES.DASHBOARD_NEW_DESIGN}
        >
          {t("design_now.text")}
        </a>
      </Button>
    </div>
  );
};
